export default __webpack_public_path__ + "static/media/nu4-removebg-preview.c0b47b41.png";